export default {
  chartType: "scatterplot",
  showTitle: true,
  showControls: true,
  showQuery: true,
  showColor: false,
  showSortZ: true,
  showSortX: false,
  showSortY: false,
  showNormalize: false,
  showRecency: true,
  showSize: true,
  showMetric: false,
  showMetricX: true,
  showMetricY: true,
  showTypeCats: true
};
